const STRING_CATCH_FIELDS = [
  "fish",
  "size",
  "weight",
  "waterType",
  "wayOfFishing",
  "typeOfFishing",
  "style",
  "technique",
  "rod",
  "reel",
  "braid",
  "leader",
  "lure",
  "lureSize",
  "lureColor",
  "hookBrand",
  "hookType",
  "hookSize",
  "knotBraidToLeader",
  "knotLeaderToLure",
  "catchAndRelease",
  "coordinates",
  "location",
  "date",
  "time",
  "feedback",
];

export const EDIT_POST_CONTEXT_FIELDS = [
  "coordinates",
  "location",
  "isLocationPublic",
  "date",
  "time",
];

export const EDITABLE_CATCH_FIELDS = [
  ...STRING_CATCH_FIELDS,
  "isLocationPublic",
  "rating",
];

const stringValue = (value) => (value == null ? "" : String(value));
const dateValue = (value) =>
  /^\d{4}-\d{2}-\d{2}$/.test(stringValue(value)) ? value : "";
const timeValue = (value) =>
  /^\d{2}:\d{2}$/.test(stringValue(value)) ? value : "";

const normalizeRating = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.min(5, Math.max(0, parsed));
};

export function getEditablePostType(post) {
  const postType = stringValue(post?.postType).trim().toLowerCase();
  if (postType === "catch" || postType === "opinion") {
    return postType;
  }
  if (!postType && post?.catch) {
    return "catch";
  }
  return "";
}

export function isEditablePost(post) {
  return Boolean(getEditablePostType(post));
}

export function buildEditPostInitialState(post) {
  const catchData = post?.catch && typeof post.catch === "object" ? post.catch : {};
  const nestedCatchData =
    catchData.catch && typeof catchData.catch === "object" ? catchData.catch : {};
  const caption = stringValue(
    post?.caption ||
      catchData.notes ||
      nestedCatchData.notes ||
      catchData.caption ||
      nestedCatchData.caption ||
      post?.description ||
      ""
  );

  return {
    caption,
    catch: {
      fish: stringValue(catchData.fish),
      size: stringValue(catchData.size),
      weight: stringValue(catchData.weight),
      waterType: stringValue(catchData.waterType),
      wayOfFishing: stringValue(catchData.wayOfFishing),
      typeOfFishing: stringValue(catchData.typeOfFishing),
      style: stringValue(catchData.style),
      technique: stringValue(catchData.technique),
      rod: stringValue(catchData.rod),
      reel: stringValue(catchData.reel),
      braid: stringValue(catchData.braid),
      leader: stringValue(catchData.leader),
      lure: stringValue(catchData.lure),
      lureSize: stringValue(catchData.lureSize),
      lureColor: stringValue(catchData.lureColor),
      hookBrand: stringValue(catchData.hookBrand),
      hookType: stringValue(catchData.hookType),
      hookSize: stringValue(catchData.hookSize),
      knotBraidToLeader: stringValue(catchData.knotBraidToLeader),
      knotLeaderToLure: stringValue(catchData.knotLeaderToLure),
      catchAndRelease: stringValue(catchData.catchAndRelease),
      rating: normalizeRating(catchData.rating),
      feedback: stringValue(catchData.feedback),
      coordinates: stringValue(catchData.coordinates),
      location: stringValue(catchData.location),
      isLocationPublic: catchData.isLocationPublic !== false,
      date: dateValue(catchData.date),
      time: timeValue(catchData.time),
    },
  };
}

export function buildEditPostPayload(post, formState) {
  const editableType = getEditablePostType(post);
  const caption = stringValue(formState?.caption);

  if (editableType === "opinion") {
    return { caption };
  }

  if (editableType !== "catch") {
    return null;
  }

  const catchState = formState?.catch || {};
  const catchPayload = {
    notes: caption,
    isLocationPublic: Boolean(catchState.isLocationPublic),
    rating: normalizeRating(catchState.rating),
  };

  STRING_CATCH_FIELDS.forEach((fieldName) => {
    catchPayload[fieldName] = stringValue(catchState[fieldName]);
  });

  return {
    caption,
    catch: catchPayload,
  };
}

export function didPostInfoContextChange(beforePost, afterPost) {
  const beforeCatch = beforePost?.catch || {};
  const afterCatch = afterPost?.catch || {};

  return EDIT_POST_CONTEXT_FIELDS.some(
    (fieldName) => beforeCatch?.[fieldName] !== afterCatch?.[fieldName]
  );
}
